import { useTranslation } from 'react-i18next';
import { MultiSelectFilter } from '@/components';

interface CategoryFilterProps {
  categories: Record<number, string>;
  selectedCategories: number[];
  onCategoryChange: (categories: number[]) => void;
  isLoading?: boolean;
}

// Company-specific wrapper that labels the shared MultiSelectFilter with the
// companies translation keys.
export function CategoryFilter({
  categories,
  selectedCategories,
  onCategoryChange,
  isLoading = false,
}: CategoryFilterProps) {
  const { t } = useTranslation();

  return (
    <MultiSelectFilter
      items={categories}
      selectedIds={selectedCategories}
      onChange={onCategoryChange}
      buttonLabel={t('companies.filter.button')}
      emptyLabel={t('companies.filter.noCategories')}
      isLoading={isLoading}
    />
  );
}
